module.exports = {"540221100":"南木林镇","540221200":"达那乡","540221201":"卡孜乡","540221202":"多角乡","540221203":"秋木乡","540221204":"艾玛乡","540221205":"土布加乡","540221206":"查尔乡","540221207":"索金乡","540221208":"达孜乡","540221209":"奴玛乡","540221210":"热当乡","540221211":"拉布普乡","540221212":"普当乡","540221213":"仁堆乡","540221214":"芒热乡","540221215":"甲措乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540221.json
// module id = 2688
// module chunks = 0